import { Col, notification, Row, Button } from "antd";
import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
import TmsTable from "../../../../components/tms-customs/tms-table";
import TmsDatePickerRange from "../../../../components/tms-customs/tms-datepicker-range";
// import TmsCounterService from "../../../../services/tms-counter.service";
import TmsShiftService from "../../../../services/tms-shift.service";
import TmsSelect from "../../../../components/tms-customs/tms-select";
import TmsExcelButton from "../../../../components/tms-customs/tms-excel-button";
import { exportExcel } from "../../../../utils/tms-excel/tms-excel";
// import TmsPartnerService from "../../../../services/partners.service";
// import { BaseContext } from "../../../../contexts/BaseContext";
import TmsAnnadanamService from "../../../../services/anndanam.service";

const TmsReportAnnadanamReport = ({ router }) => {
  // const { userDetails } = useContext(BaseContext);

  const [loading, setLoading] = useState();
  const [excelLoading, setExcelLoading] = useState(false);

  const [bookingDetails, setBookingDetails] = useState([]);
  const [bookingFromDate, setBookingFromDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [bookingToDate, setBookingToDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [dateType, setDateType] = useState("performanceDate");

  const [sortType, setSortType] = useState("ASC");
  // const [bookingType, setBookingType] = useState("pos");
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [annadanamType, setAnnadanamType] = useState("");
  const [annadanamList, setAnnadanamList] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("success");
  // const [allPartnerList, setAllPartnerList] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState("");
  const [counter, setCounter] = useState("");

  const [shift, setShift] = useState("");
  const [shiftList, setShiftList] = useState([]);

  const [slot, setSLot] = useState("");
  const [slotList, setSlotList] = useState([]);

  const API = {
    online: TmsAnnadanamService.annadanamReport,
    pos: TmsAnnadanamService.annadanamReport,
  };
  const fetchBookingDetails = async () => {
    setLoading(true);
    try {
      const data = await API["pos"]({
        format: "json",
        tableCurrentPage: Number(tableCurrentPage),
        tablePageSize: Number(tablePageSize),
        fromDate: bookingFromDate,
        toDate: bookingToDate,
        dateType,
        sortType,
        counter,
        shift,
        slot,
        annadanamType,
        paymentStatus,
        selectedPartner,
      });

      setTabelTotalSize(data?.meta?.totalItems);
      setBookingDetails(
        data?.items?.map((item) => {
          return { key: item?.bookingId, ...item };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    setLoading(false);
  };
  // const fetchAllPartners = async () => {
  //   setLoading(true);
  //   try {
  //     const data = await TmsPartnerService.getPartnersByTemple();
  //     setAllPartnerList(data);
  //     setLoading(false);
  //   } catch (error) {
  //     catchErrorFunction(
  //       error,
  //       "Token Expired, redirecting to login page in 5 seconds",
  //       router
  //     );
  //     setLoading(false);
  //   }
  // };

  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
    if (sorter.field === "createdDate") {
      if (sorter.order === "ascend") {
        setSortType("ASC");
      } else if (sorter.order === "descend") {
        setSortType("DESC");
      }
    }
  };
  const fetchAnnadanamList = async () => {
    try {
      let res = await TmsAnnadanamService.getAnnadanam(1, 500);
      setAnnadanamList(res.annadanams);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };

  const fetchAnnadanamSlotList = async (id) => {
    try {
      let res = await TmsAnnadanamService.getAnnadanamSlots(id);
      setSlotList(res);
    } catch (e) {
      notification.error({ message: e?.message });
    }
  };
  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      let data = await API["pos"]({
        format: "json",
        tableCurrentPage: Number(1),
        tablePageSize: Number(70000),
        fromDate: bookingFromDate,
        toDate: bookingToDate,
        dateType,
        sortType,
        counter,
        shift,
        slot,
        darshanamType: annadanamType,
        paymentStatus,
        selectedPartner,
      });

      data = data?.items?.reverse();
      let compiledDataOffile = [];
      {
        compiledDataOffile = data.map((item, i) => {
          return {
            "S.no": i + 1,
            "Annadanam Type ": item.annadanamName,
            "POS Name": item.counterName,
            Shift: item.shiftName,
            "Booking Id": item.bookingId,
            "Transaction Id": item?.categoryTransactionSequence
              ?.split("-")
              ?.pop(),
            "No of persons": item.noOfPersons,
            Amount: item?.amount,
            Slot: item.slot,
            "Booked On": moment(item?.created_at).format("DD-MM-YYYY hh:mm A"),

            "Performance Date": item.seva_date
              ? moment(item.seva_date).format("DD-MM-YYYY")
              : "-",
          };
        });
      }

      exportExcel(
        compiledDataOffile,
        `annadanam-report-${"pos"}-${moment().format("DD-MM-YYYY")}`,
        setExcelLoading
      );
    } catch (error) {
      catchErrorFunction(error, "Token expired!! Please login again.", router);
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnadanamList();
    // fetchCounterList();
    // fetchShiftList();

    // bookingType === "online" &&
    //   (userDetails?.permissions.includes("SUPER_ADMIN") ||
    //     userDetails?.permissions.includes("ADMIN")) &&
    //   fetchAllPartners();
  }, []);

  useEffect(() => {
    fetchBookingDetails();
  }, [tableCurrentPage, tablePageSize]);

  const columns = [
    {
      title: "S.no",
      key: "sno",
      width: "20px",
      render: (text, object, index) => index + 1,
    },
    {
      title: "POS Name",
      dataIndex: "counterName",
      key: "counterName",
    },
    {
      title: "Shift",
      dataIndex: "shiftName",
      key: "shiftName",
    },
    // {
    //   title: "Booking Id",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "Txn Id",
      dataIndex: "categoryTransactionSequence",
      render: (text) => text?.split("-")?.pop(),
    },
    {
      title: "Txn S no",
      dataIndex: "dailyCategoryTransactionSequence",
      render: (text) => text?.split("-")?.pop(),
    },
    {
      title: "Annadanam Type",
      dataIndex: "annadanamName",
      key: "annadanamName",
    },
    {
      title: "No of Persons",
      dataIndex: "noOfPersons",
      key: "noOfPersons",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => {
        return `Rs. ${text}`;
      },
    },

    {
      title: "Slot",
      dataIndex: "slot",
      key: "slot",
    },
    {
      title: "Annadanam Date",
      dataIndex: "annadanamDate",
      render: (record) => {
        return moment(record).format("DD-MM-YYYY");
      },
      sorter: (a, b) => a.annadanamDate > b.annadanamDate,
    },
    {
      title: "Booked On",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => {
        return moment(text).format("DD-MM-YYYY");
      },
      defaultSortOrder: "descend",
      sorter: (a, b) => a.created_at > b.created_at,
    },
  ];

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={6}>
          <TmsDatePickerRange
            className={"m-0"}
            label="Time period"
            to={bookingToDate}
            from={bookingFromDate}
            setFrom={setBookingFromDate}
            setTo={setBookingToDate}
          />
        </Col>
        {/* <TmsSelect
          type="col"
          span={3}
          label="Booking Type"
          setValue={setBookingType}
          value={bookingType}
          data={[
            { id: "pos", name: "pos" },
            { id: "online", name: "online" },
          ]}
          optional={true}
        />
        {bookingType === "online" &&
          (userDetails?.permissions.includes("SUPER_ADMIN") ||
            userDetails?.permissions.includes("ADMIN")) && (
            <TmsSelect
              type="col"
              span={4}
              selectClass="w-100"
              label="Partner Type"
              setValue={setSelectedPartner}
              value={selectedPartner}
              data={allPartnerList.map((item) => {
                return {
                  id: item.partnerCode,
                  name: `${item?.partnerName} - ${item?.partnerCode}`,
                };
              })}
            />
          )} */}
        <TmsSelect
          type="col"
          span={10}
          selectClass="w-100"
          label="Annadanam Type"
          setValue={(e) => {
            setAnnadanamType(e);
            if (e === "") {
              setSLot("");
              return;
            }
            fetchAnnadanamSlotList(e);
          }}
          value={annadanamType}
          data={annadanamList}
        />

        {/* {bookingType === "pos" && (
          <>
            {" "}
            <TmsSelect
              type="col"
              span={5}
              label="POS"
              setValue={setCounter}
              value={counter}
              data={counterList}
            />
            <TmsSelect
              type="col"
              span={3}
              label="Shift"
              setValue={setShift}
              value={shift}
              data={shiftList}
            />
          </>
        )} */}
        {/* <TmsSelect
          type="col"
          span={bookingType === "online" ? 6 : 3}
          label="Slot"
          setValue={setSLot}
          value={slot}
          data={slotList}
        /> */}

        <TmsSelect
          type="col"
          span={3}
          label="Date Type"
          setValue={setDateType}
          value={dateType}
          data={[
            { id: "performanceDate", name: "Performance" },
            { id: "orderDate", name: "Booking" },
          ]}
          optional={true}
        />

        <Col>
          <Row justify="start" style={{ marginBottom: "5px" }}>
            Update
          </Row>
          <Button type="primary" onClick={fetchBookingDetails}>
            Fetch
          </Button>
        </Col>
        <TmsExcelButton
          loading={excelLoading}
          handleExcelExport={handleExcelExport}
          top={true}
        />
      </Row>
      <br />
      <Row>
        <TmsTable
          columns={columns}
          dataSource={bookingDetails}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        ></TmsTable>
      </Row>
    </>
  );
};

export default withRouter(TmsReportAnnadanamReport);
